var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    fill: "#F8F9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    stroke: "#FAFBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 15.625H13.75C13.2527 15.625 12.7758 15.8225 12.4242 16.1742C12.0725 16.5258 11.875 17.0027 11.875 17.5V20.3125C11.875 20.8098 12.0725 21.2867 12.4242 21.6383C12.7758 21.99 13.2527 22.1875 13.75 22.1875V32.5C13.75 32.9973 13.9475 33.4742 14.2992 33.8258C14.6508 34.1775 15.1277 34.375 15.625 34.375H34.375C34.8723 34.375 35.3492 34.1775 35.7008 33.8258C36.0525 33.4742 36.25 32.9973 36.25 32.5V22.1875C36.7473 22.1875 37.2242 21.99 37.5758 21.6383C37.9275 21.2867 38.125 20.8098 38.125 20.3125V17.5C38.125 17.0027 37.9275 16.5258 37.5758 16.1742C37.2242 15.8225 36.7473 15.625 36.25 15.625ZM27.8125 26.875H22.1875C21.9389 26.875 21.7004 26.7762 21.5246 26.6004C21.3488 26.4246 21.25 26.1861 21.25 25.9375C21.25 25.6889 21.3488 25.4504 21.5246 25.2746C21.7004 25.0988 21.9389 25 22.1875 25H27.8125C28.0611 25 28.2996 25.0988 28.4754 25.2746C28.6512 25.4504 28.75 25.6889 28.75 25.9375C28.75 26.1861 28.6512 26.4246 28.4754 26.6004C28.2996 26.7762 28.0611 26.875 27.8125 26.875ZM36.25 20.3125H13.75V17.5H36.25V20.3125Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveModalIcon);
export default __webpack_public_path__ + "static/media/ArchiveModalIcon.c3159e3a4ac7fabc7a197f033557c0ee.svg";
export { ForwardRef as ReactComponent };